export const selfPixelsSelector = (state) => state.fb.pixels;
